import type { StateCreator } from 'zustand';
import type { ItineraryState } from '../itinerary-store';

export interface DirtyEntryState {
  fields: string[];
  isNew: boolean;
  retryCount: number;
  retryAt: number | null;
  /** Set when scheduleRetry has hit the BACKOFF ceiling — the entry is no
   *  longer being auto-retried. The user has to manually retry or discard.
   *  The sync pill reads this to surface a distinct "Sync stopped" state. */
  retryExhausted?: boolean | undefined;
}

export interface SyncSlice {
  dirtyTrips: Record<string, DirtyEntryState>;
  pendingDeletes: string[];
  setDirtyEntry: (tripId: string, entry: DirtyEntryState) => void;
  clearDirtyEntry: (tripId: string) => void;
  addPendingDelete: (tripId: string) => void;
  removePendingDelete: (tripId: string) => void;
}

export const createSyncSlice: StateCreator<ItineraryState, [], [], SyncSlice> = (set) => ({
  dirtyTrips: {},
  pendingDeletes: [],

  setDirtyEntry: (tripId, entry) => set((s) => ({
    dirtyTrips: { ...s.dirtyTrips, [tripId]: entry },
  })),

  clearDirtyEntry: (tripId) => set((s) => {
    const next = { ...s.dirtyTrips };
    delete next[tripId];
    return { dirtyTrips: next };
  }),

  addPendingDelete: (tripId) => set((s) => ({
    pendingDeletes: [...s.pendingDeletes.filter((id) => id !== tripId), tripId],
  })),

  removePendingDelete: (tripId) => set((s) => ({
    pendingDeletes: s.pendingDeletes.filter((id) => id !== tripId),
  })),
});
